<section>
  <div class="header">
    <h3>
      Session notes for {{booking.studentName}}
    </h3>
    <h5>Session on {{booking.startDateTime | date: 'MMM d, yyyy @h:mm a'}}</h5>
  </div>
  <div class="body">
    <div class="row">
      <div class="col-12 col-sm-12 col-xs-12">
        <ckeditor [editor]="Editor" (change)="onChange($event)" data="{{editorText}}">
        </ckeditor>
      </div>
    </div>
  </div>
  <br />
  <div class="row">
    <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mb-2">
      <button class="msr-3" mat-raised-button color="primary" (click)="saveNotes()">Submit</button>
      <button type="button" mat-button (click)="cancel()">Cancel</button>
    </div>
  </div>
</section>